import React from 'react';
import { InputProps } from '../../../types';
import { getInputStyles } from './styles';

export const DateInput: React.FC<InputProps<string>> = ({ 
  value, 
  onChange, 
  readOnly, 
  placeholder, 
  hasError, 
  isOverridden 
}) => {
  return (
    <input
      type="date"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={readOnly}
      className={getInputStyles(readOnly, hasError, isOverridden)}
      placeholder={placeholder}
    />
  );
};
